import React from "react";
import { connect } from "react-redux";
import { setSelectedCard } from "../../store/actions/passiveIncomeActions";
import iconPlay from "../../assets/icon-start.png";

const CircleCoins = ({
  coins,
}) => {
  return (
    <div className="overlap">
      {coins.map((coin, i) => (
        <div
          key={coin.name}
          className="circle"
          style={{ backgroundImage: `url(${coin.image})`, zIndex: coins.length - i }}
          title={coin.name}
        />
      ))}
    </div>
  );
};

const Card = ({
  coins,
  contractAge,
  currentTVL,
  description,
  externalLink,           
  opportunityName,
  playLink,
  risk,
  type,
  yieldPercent,
  id,
  setSelectedCard,
  selectedCard,
  thumb
}) => {
  const handleSelectedCard = (itemCard) => {
    setSelectedCard(itemCard)
  };
  const formatCompact = (num) => {
    return num.toLocaleString("en-US", {
      notation: "compact",
      maximumFractionDigits: 1,
    });
  };

  return (
    <div 
      className={selectedCard === id ? "card active" : "card"} 
      onClick={() => handleSelectedCard(id)}
    >
      <div className="card-left">
        <CircleCoins coins={coins} />
        <div className="card-title">
          {opportunityName}
        </div>

        <div className="card-description">
          <div>
            <p>{description}</p>
          </div>
        </div>

        <div className="card-info">
          <div><strong>Risco de contraparte:</strong> <span>{risk}</span></div>
          <div><strong>Idade do contrato:</strong> <span>{`${contractAge} Dias`}</span></div>
          <div><strong>TVL atual:</strong> <span>{`$${formatCompact(currentTVL)}`}</span></div>
        </div>
      </div>

      <div className="card-right">
        <div className="yield-info">
          <div className="yield-value">{`${yieldPercent}%`}</div>
          <div 
            className="yield-type"
            style={{ 
              backgroundColor: type === "prefixado" 
              ? "#2d9cdbc4" 
              : "#eb57579e",
              color: type === "prefixado" 
              ? "#03121691" 
              : "#3f1818",
            }}
          >
            {type === "prefixado" ? "Pré-fixado" : type}
          </div>
        </div>

        <div className="card-actions card-play">
          <a href={playLink} target="_blank" rel="noopener noreferrer" className="play-btn">
            <img src={iconPlay} alt="icon play" className="icon-play" />
            <img src={thumb} alt="thumb video" className="thumb-img" />
          </a>
        </div>

        <div className="card-actions card-enter">
          <a href={externalLink} target="_blank" rel="noopener noreferrer" className="enter-btn">Entrar</a>
        </div>
      </div>

      
    </div>
  );
}; 

const mapStateToProps = (state) => ({
  selectedCard: state.opportunities.selectedCard,
});

export default connect(mapStateToProps, { setSelectedCard })(Card);

